import { render, staticRenderFns } from "./InstagramTemplate.vue?vue&type=template&id=3bf7f43a&scoped=true&"
import script from "./InstagramTemplate.vue?vue&type=script&lang=ts&"
export * from "./InstagramTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./InstagramTemplate.vue?vue&type=style&index=0&id=3bf7f43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf7f43a",
  null
  
)

export default component.exports